import React from 'react';
import { getApiBase } from '../apiBase';

const LS_KEY = 'howto_payments_settings';

export default function PaymentsPanel({ ownerId, onClose }) {
  const [connected, setConnected] = React.useState(false);
  const [settings, setSettings] = React.useState(() => {
    try {
      const raw = localStorage.getItem(LS_KEY);
      const parsed = raw ? JSON.parse(raw) : null;
      // Guard against corrupt/non-object stored values (null, arrays, primitives).
      if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) return parsed;
      return { offerFinancing: true };
    } catch (_) {
      return { offerFinancing: true };
    }
  });

  React.useEffect(() => {
    try {
      localStorage.setItem(LS_KEY, JSON.stringify(settings));
    } catch (_) {}
  }, [settings]);

  const checkStripe = React.useCallback(async () => {
    try {
      const res = await fetch(`${getApiBase()}/api/owner/payments/status`);
      if (!res.ok) return;
      const data = await res.json();
      // Same endpoint as InvoicingPanel, which reads `stripeConfigured`.
      // Accept either field so the two panels can't disagree on connection state.
      setConnected(!!(data && (data.connected || data.stripeConfigured)));
    } catch (_) {}
  }, [ownerId]);

  React.useEffect(() => { checkStripe(); }, [checkStripe]);

  const methods = [
    'Card (Visa / MC / Amex)',
    'Bank transfer (ACH)',
    'Apple Pay / Google Pay',
    'Cash App',
    'Financing — Affirm / Klarna / Afterpay',
  ];

  return (
    <div className="agent-detail" onClick={onClose}>
      <div className="agent-detail__panel" onClick={(e) => e.stopPropagation()}>
        <button type="button" className="agent-detail__close" onClick={onClose} aria-label="Close">×</button>
        <div className="agent-detail__title">Payments</div>
        <div className="agent-detail__cadence">Per job</div>
        <p className="agent-detail__desc">
          You review the invoice, tap Send, and the customer pays — the full amount up front or over time with financing.
        </p>

        <div className="agent-detail__section">How customers can pay</div>
        <ul className="agent-detail__list">
          {methods.map((m) => <li key={m}>{m}</li>)}
        </ul>

        <label className="sched-toggle">
          <input
            type="checkbox"
            checked={!!settings.offerFinancing}
            onChange={(e) => setSettings((s) => ({ ...s, offerFinancing: e.target.checked }))}
          />
          <span>Offer financing on invoices over {(1000).toLocaleString('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 })}</span>
        </label>

        {connected ? (
          <div className="agent-detail__status sched-ok">Stripe connected — you can take payment online.</div>
        ) : (
          <div className="sched-warn">Taking payment online needs Stripe connected.</div>
        )}

        <button
          type="button"
          className="agent-detail__cta"
          onClick={() => window.open('https://dashboard.stripe.com/apikeys', '_blank')}
        >
          {connected ? 'Open Stripe dashboard' : 'Connect Stripe'}
        </button>

        <button type="button" className="sched-refresh" onClick={checkStripe}>Refresh status</button>

        <div className="agent-detail__note">
          Cash &amp; check are recorded by hand. Venmo would need PayPal added.
        </div>
      </div>
    </div>
  );
}
